import type { SelectOption } from '@ps/ui';
import {
  TrackerExclusionRule,
  TrackerFrequencyUnit,
  TRACKER_FREQUENCY_UNIT_LABELS,
} from '@ps/survey-utils';

const FREQUENCY_UNITS: readonly TrackerFrequencyUnit[] = ['d', 'w', 'm', 'q'];

export const TRACKER_CONFIG_DRAWER_FREQUENCY_UNIT_OPTIONS: SelectOption<TrackerFrequencyUnit>[] =
  FREQUENCY_UNITS.map((value) => ({
    value,
    label: TRACKER_FREQUENCY_UNIT_LABELS[value],
  }));

export const TRACKER_CONFIG_DRAWER_EXCLUSION_RULE_OPTIONS: SelectOption<
  TrackerExclusionRule['kind']
>[] = [
  {
    value: 'lastWave',
    label: 'Exclude Last Wave',
    caption:
      'Exclude last wave: Wave B excludes A. Wave C excludes B (Wave A can rejoin)',
  },
  {
    value: 'lastTwoWaves',
    label: 'Exclude Last Two Waves',
    caption:
      'Exclude last two waves: Wave C excludes A & B. Wave D excludes B & C (Wave A can rejoin)',
  },
  {
    value: 'lastThreeWaves',
    label: 'Exclude Last Three Waves (Recommended Maximum)',
    caption:
      'Exclude last three waves: Wave D excludes A, B & C. Wave E excludes B, C & D (Wave A can rejoin)',
  },
  {
    value: 'allPreviousWaves',
    label: 'Exclude All Previous Waves',
    caption:
      'Exclude all previous waves: each wave only gets completely fresh respondents who have not participated before.',
  },
  {
    value: 'custom',
    label: 'Custom',
    caption:
      'Custom: you can exclude respondents from up to the total number of waves in your survey.',
  },
];
